import { SignIn } from "@clerk/react";
import { Zap } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import LanguageSwitcher from "@/components/LanguageSwitcher";

export default function SignInPage() {
  const { t } = useI18n();
  return (
    <div className="min-h-screen bg-[#F2F2F0] grain">
      <header className="brutal-border border-l-0 border-r-0 border-t-0 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="bg-[#FF3311] brutal-border w-10 h-10 flex items-center justify-center">
              <Zap className="w-6 h-6 text-white" strokeWidth={3} />
            </div>
            <div>
              <div className="font-display text-xl md:text-2xl uppercase leading-none">
                {t("app.name")}
              </div>
              <div className="font-mono text-[10px] uppercase tracking-widest text-neutral-500">
                {t("app.tagline")}
              </div>
            </div>
          </div>
          <LanguageSwitcher />
        </div>
      </header>
      <main className="max-w-5xl mx-auto px-6 md:px-10 py-10 md:py-16 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        <div>
          <div className="inline-block bg-[#E5FF00] brutal-border px-3 py-1 font-mono text-xs uppercase tracking-widest mb-5">
            {t("hero.badge")}
          </div>
          <h1 className="font-display uppercase text-4xl sm:text-5xl leading-[0.95] tracking-tight">
            {t("signIn.title")}
          </h1>
          <p className="mt-5 font-mono text-sm md:text-base text-neutral-700 max-w-md">
            {t("signIn.subtitle")}
          </p>
        </div>
        <div className="flex items-center justify-center">
          <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp />
        </div>
      </main>
    </div>
  );
}
